export default /* html */ `
<ui-base-button
  class="ui-icon-button"
  *bind:class="buttonClasses"
  *bind:type="type"
  *bind:disabled="disabled ? '' : null"
  *ref="button"
>
  <ui-ripple slot="ripple"></ui-ripple>

  <slot slot="icon-start"></slot>

</ui-base-button>
`
